import React, { useEffect } from 'react';
import AuthLayout from '../../AuthLayout/AuthLayout';
import {
  Button,
  ButtonGroup,
  Circle,
  ContinueButton,
  PageContainer,
  SubTitle,
  Title,
  Navigation,
  NavigationLink,
  EmailText,
} from './SignUpOptionsPage.styles';
import environment from '../../../environment';
import { useSelector } from 'react-redux';
import { getPreLoginEmail } from '../../../selectors/auth';

const SignUpOptionsPage = () => {
  const [redirect, setRedirect] = React.useState(null);
  const preLoginEmail = useSelector(getPreLoginEmail);
  const [selectedOption, setSelectedOption] = React.useState('');

  useEffect(() => {
    if (redirect) {
      window.location.href = redirect;
    }
  }, [redirect]);

  function partnerOptionSelectHandler() {
    setSelectedOption('partner');
  }

  function expertOptionSelectHandler() {
    setSelectedOption('expert');
  }

  function continueHandler() {
    if (selectedOption === 'partner') {
      setRedirect(environment.auth.partnerSignUpPage);
    } else if (selectedOption === 'expert') {
      setRedirect(environment.auth.expertSignUpPage);
    }
  }

  const Controls = (
    <Navigation>
      <NavigationLink to="/">Back</NavigationLink>
    </Navigation>
  );

  return (
    <AuthLayout controls={Controls}>
      <PageContainer>
        <Title>Create your account</Title>
        <SubTitle>
          We didn't find an account for
          <EmailText>{preLoginEmail ?? 'your email'}</EmailText>
          <div>Select an option below to sign up.</div>
        </SubTitle>
        <ButtonGroup>
          <Button onClick={partnerOptionSelectHandler}>
            <Circle selected={selectedOption === 'partner'} />
            I’m a Partner
          </Button>
          <Button onClick={expertOptionSelectHandler}>
            <Circle selected={selectedOption === 'expert'} />
            I’m an Expert
          </Button>
        </ButtonGroup>
        <ContinueButton onClick={continueHandler}>Continue</ContinueButton>
      </PageContainer>
    </AuthLayout>
  );
};

export default SignUpOptionsPage;
